import { Component, computed, input, output } from '@angular/core';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'app-confirm',
  imports: [ButtonComponent],
  templateUrl: './confirm.component.html',
  styleUrl: './confirm.component.css',
})
export class ConfirmComponent {
  public context = input.required<'feedback' | 'user'>();
  protected text = computed(() => {
    if (this.context() === 'feedback') {
      return {
        title: $localize`Leave survey?`,
        content: $localize`When leaving the survey, your answers will be saved, and you will no longer be able to change your answers.`,
        confirm: $localize`Leave survey`,
        cancel: $localize`Continue survey`,
      };
    }

    return {
      title: $localize`Discard changes?`,
      content: $localize`When you leave without saving, your changes will be discarded.`,
      confirm: $localize`Discard changes`,
      cancel: $localize`Continue editing`,
    };
  });
  public confirmAction = output<void>();
  public cancelAction = output<void>();

  protected handleConfirm() {
    this.confirmAction.emit();
  }

  protected handleCancel() {
    this.cancelAction.emit();
  }
}
